import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineTemplateDto extends EpimsBaseEntityDto {
    PipelineTemplateName: string;
    CreatedByName: string;
    SubscriptionUserId: string;
    Status: string;
}
